module.exports = __webpack_public_path__ + "img/window-5.6530713d.jpg";